import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { prices } from "../futils";
import { listProducts } from "../actions/productActions";
import Footer from "../components/footer";
import LoadingBox from "../components/loadingBox";
import MessageBox from "../components/messageBox";
import NavBar from "../components/navbar";
import Products from "../components/products";

function SearchPage(props) {
  const {
    name = "all",
    category = "all",
    min = 0,
    max = 0,
    order = "newest",
    pageNumber = 1,
  } = useParams();

  const dispatch = useDispatch();

  const productList = useSelector((state) => state.productList);
  const { loading, error, products, page, pages } = productList;

  // console.log(products);

  const productCategoryList = useSelector((state) => state.productCategoryList);
  const {
    loading: loadingCategories,
    error: errorCategories,
    categories,
  } = productCategoryList;

  // console.log(categories);
  // console.log(productCategoryList);

  useEffect(() => {
    dispatch(
      listProducts({
        pageNumber,
        name: name !== "all" ? name : "",
        category: category !== "all" ? category : "",
        min,
        max,
        order,
      })
    );
  }, [dispatch, name, category, max, min, order, pageNumber]);

  const getFilterUrl = (filter) => {
    const filterPage = filter.page || pageNumber;
    const filterCategory = filter.category || category;
    const filterName = filter.name || name;
    const sortOrder = filter.order || order;
    const filterMin = filter.min ? filter.min : filter.min === 0 ? 0 : min;
    const filterMax = filter.max ? filter.max : filter.max === 0 ? 0 : max;
    return `/search/category/${filterCategory}/name/${filterName}/min/${filterMin}/max/${filterMax}/order/${sortOrder}/pageNumber/${filterPage}`;
  };

  return (
    <div>
      <NavBar />
      <div className="container pt-5 pb-4">
        <div className="d-flex justify-content-between pb-3">
          {loading ? (
            <LoadingBox></LoadingBox>
          ) : error ? (
            <MessageBox variant="danger">{error}</MessageBox>
          ) : (
            <div className="fst-italic ">
              {products.products.length} results
            </div>
          )}
          <div className="row">
            <div className="col pt-2 sort_by ">Sort By</div>
            <div className="col">
              <select
                className="form-select product_sort"
                value={order}
                onChange={(e) => {
                  props.history.push(getFilterUrl({ order: e.target.value }));
                }}
              >
                <option value="newest">Newest Arrivals</option>
                <option value="lowest">Price Ascending</option>
                <option value="highest">Price Descending</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div className="container  pt-2 pb-3">
        <div className="row">
          <div className="col-md-2  d-none d-sm-block ">
            <div>
              <span className="fw-bold">Department</span>
              {loadingCategories ? (
                <LoadingBox></LoadingBox>
              ) : errorCategories ? (
                <MessageBox variant="danger">{errorCategories}</MessageBox>
              ) : (
                <ul className="list-unstyled ">
                  <li>
                    <Link
                      className={
                        "all" === category
                          ? "active text-decoration-none fw-bold link-secondary searchinfo "
                          : "text-decoration-none link-secondary searchinfo "
                      }
                      to={getFilterUrl({ category: "all" })}
                    >
                      Any
                    </Link>
                  </li>
                  {categories.map((c) => (
                    <li key={c}>
                      <Link
                        className={
                          c === category
                            ? "active text-decoration-none fw-bold link-secondary searchinfo "
                            : "text-decoration-none link-secondary searchinfo "
                        }
                        to={getFilterUrl({ category: c })}
                      >
                        {c}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <div>
              <span className="fw-bold">Price</span>
              <ul className="list-unstyled ">
                {prices.map((p) => (
                  <li key={p.name}>
                    <Link
                      to={getFilterUrl({ min: p.min, max: p.max })}
                      className={
                        `${p.min}-${p.max}` === `${min}-${max}`
                          ? "active text-decoration-none fw-bold link-secondary searchinfo "
                          : "text-decoration-none link-secondary searchinfo "
                      }
                    >
                      {p.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="col-12 col-md-10  ">
            {loading ? (
              <LoadingBox></LoadingBox>
            ) : error ? (
              <MessageBox variant="danger">{error}</MessageBox>
            ) : (
              <>
                {products.length === 0 && (
                  <MessageBox>No Product Found</MessageBox>
                )}

                <div>
                  <Products products={products.products}></Products>
                </div>
                <div className="row d-flex">
                  <ul className="pagination mx-auto justify-content-center pt-4">
                    {[...Array(pages).keys()].map((x) => (
                      <li className="page-item px-2 fst-italic" key={x + 1}>
                        <Link
                          className={
                            x + 1 === page
                              ? "active text-decoration-none fw-bold "
                              : "text-decoration-none  "
                          }
                          to={getFilterUrl({ page: x + 1 })}
                        >
                          {x + 1}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default SearchPage;
